/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as SeoLocationPageLoader } from './SeoLocationPage/SeoLocationPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';

const getPageDataLoadingAPI = () => {
  return {
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    SeoLocationPage: {
      loadData: SeoLocationPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
